import { useState, useEffect } from "react";
import { FaFilter } from "react-icons/fa";
import Select from "react-select";
import "./DataTable.css";
import Spinner from "../../../screens/Spin/Spinner";

const DataTable = ({
  columns,
  data,
  loading,
  emptyMessage = "No Data Found",
  rowClassName,
}) => {
  const [openFilter, setOpenFilter] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dataTable-filterContainer")) {
        setOpenFilter(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const renderFilter = (column) => {
    switch (column.filterType) {
      case "select":
        return (
          <div className="dataTable-filterDropdown">
            <Select
              options={column.filterOptions}
              value={column.filterOptions.find(
                (option) => option.value === column.filterValue,
              )}
              onChange={(option) => {
                column.onFilterChange(option?.value || "All");
                setOpenFilter(null);
              }}
            />
          </div>
        );

      case "menu":
        return (
          <div className="dataTable-filterMenu">
            {column.filterOptions.map((option) => (
              <p
                key={option.value}
                className="dataTable-filterItem"
                onClick={() => {
                  column.onFilterChange(option.value);
                  setOpenFilter(null);
                }}
              >
                {option.label}
              </p>
            ))}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <table className="dataTable">
      <thead>
        <tr>
          {columns.map((column) => (
            <th
              key={column.key}
              {...column.thProps}
              className={`
                dataTable-header
                ${column.filterable ? "dataTable-header--filterable" : ""}
                ${column.wrapHeader ? "dataTable-wrapHeader" : ""}
              `}
            >
              <div className="dataTable-filterContainer">
                <div className="dataTable-headerContent">
                  <span className="dataTable-headerText">{column.header}</span>

                  {column.filterable && (
                    <FaFilter
                      className="dataTable-filterIcon"
                      onClick={(e) => {
                        e.stopPropagation();

                        setOpenFilter(
                          openFilter === column.key ? null : column.key
                        );
                      }}
                    />
                  )}
                </div>

                {openFilter === column.key && renderFilter(column)}
              </div>
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {loading ? (
          <tr>
            <td colSpan={columns.length}>
              <Spinner />
            </td>
          </tr>
        ) : data?.length ? (
          data.map((row, index) => (
            <tr
              key={row.id || index}
              className={`dataTable-row ${
                typeof rowClassName === "function"
                  ? rowClassName(row)
                  : rowClassName || ""
              }`}
            >
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={`
                    dataTable-cell
                    ${column.wrapCell ? "dataTable-wrapCell" : ""}
                  `}
                >
                  {column.render ? column.render(row, index) : row[column.key]}
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={columns.length} className="dataTable-message">
              {emptyMessage}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default DataTable;